export const waitFor = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

export const createEmptyTableData = (columns = [], noRows = 10) => {
  const dataArr = [];
  Array(noRows)
    .fill()
    .forEach(() => {
      const rowObject = {};
      for (const columnName of columns) {
        rowObject[columnName] = '--';
      }
      dataArr.push(rowObject);
    });

  return dataArr;
};
